module.exports = __webpack_public_path__ + "img/05_sub_no.2b80f2ab.svg";